export default __webpack_public_path__ + "static/media/proper-sleep.aa175042.svg";